import { useTranslation } from "@vixi/localization";
import { useSyncExternalStore } from "react";
import { Collapse } from "./animation/collapse";

function onlineStatusSubscribe(cb: (status: "online" | "offline") => void) {
  const onlineListener = () => cb("online");
  addEventListener("online", onlineListener);

  const offlineListener = () => cb("offline");
  addEventListener("offline", offlineListener);

  return () => {
    removeEventListener("online", onlineListener);
    removeEventListener("offline", offlineListener);
  };
}

function onlineStatusSnapshot() {
  return navigator.onLine ? ("online" as const) : ("offline" as const);
}

export const CheckConnection = () => {
  const { t } = useTranslation();
  const onlineStatus = useSyncExternalStore(onlineStatusSubscribe, onlineStatusSnapshot);

  return (
    <Collapse in={onlineStatus === "offline"}>
      <div className="bg-destructive text-destructive-foreground p-0.25">
        <p className="fs-12 text-center">{t("ConnectionStatus.Offline")}</p>
      </div>
    </Collapse>
  );
};
